import {bool, func} from 'prop-types';
import {useEffect} from 'react';
import {useParams} from 'react-router-dom';

import {useMesocycle} from '../api.js';

export default function ExerciseRepeatSwitch({repeat, setRepeat}) {
  const {mesoKey, week} = useParams();
  const {data: meso} = useMesocycle(mesoKey);
  const isDeloadLoadWeek = meso.weeks.length === Number(week);

  useEffect(() => {
    if (isDeloadLoadWeek && repeat) {
      setRepeat(false);
    }
  }, [isDeloadLoadWeek, repeat, setRepeat]);

  if (isDeloadLoadWeek) {
    return null;
  }

  return (
    <div className="form-control">
      <label className="label flex cursor-pointer justify-start gap-3">
        <input
          type="checkbox"
          checked={repeat}
          onChange={e => {
            setRepeat(!!e.target.checked);
          }}
          className="checkbox outline-none" // TODO: make this accent if it's checked
        />
        <span className="label-text">Repeat until the end of this mesocycle</span>
      </label>
    </div>
  );
}

ExerciseRepeatSwitch.propTypes = {
  repeat: bool,
  setRepeat: func,
};
